<entity-comments
	[commentsList]="config().data.comments"
	[requester]="requestees"
	[entity]="config().data"
	(deleteComment)="deleteCommentConfirmation($event)"
	(editComment)="editComment($event)"
	(commentSubmitted)="submitComment($event)"
></entity-comments>
